import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SingleToggleButton from './SingleToggleButton';

import './ToggleButtons.scss';

class ToggleButtons extends React.Component {
  static propTypes = {
    style: PropTypes.string,
    underlineSelected: PropTypes.bool,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        action: PropTypes.func,
        title: PropTypes.node,
        isSelected: PropTypes.bool,
        className: PropTypes.string,
        qaTag: PropTypes.string,
      }),
    ),
  };

  render() {
    const buttons = [];
    for (let i = 0; i < this.props.buttons.length; i++) {
      buttons.push(
        <SingleToggleButton
          key={`toggleButton-${i}`}
          button={this.props.buttons[i]}
          underlineSelected={this.props.underlineSelected}
        />,
      );
    }

    const rootClass = classNames('ToggleButtons', {
      [`ToggleButtons--${this.props.style}`]: this.props.style,
    });

    return <div className={rootClass}>{buttons}</div>;
  }
}

export default ToggleButtons;
